// Ölçüm iznini ve mevcut OpenAI referanslarını özel sepet alanlarıyla siparişe taşır.
// Ödeme/checkout akışını bekletmez; yalnız bu dört alanı günceller.
(() => {
  if (window.selsilOpenaiSyncCart) return;
  let writing = false;
  let desired;
  let savedFingerprint;
  const permission = () => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return privacy?.marketingAllowed() === true && privacy?.saleOfDataAllowed() === true;
    } catch { return false; }
  };
  const cookie = (name) => {
    try {
      const row = document.cookie.split(';').map(value => value.trim()).find(value => value.startsWith(`${name}=`));
      return row ? decodeURIComponent(row.slice(name.length + 1)) : '';
    } catch { return ''; }
  };
  const attributes = () => {
    const allowed = permission();
    let oppref = '';
    if (allowed) {
      try { oppref = new URL(window.location.href).searchParams.get('oppref') || cookie('__oppref'); } catch {}
    }
    return {
      __openai_measurement_consent: allowed ? 'yes' : 'no',
      __openai_consent_recorded_at: new Date().toISOString(),
      __openai_oppref: oppref,
      __openai_obref: allowed ? cookie('__obref') : '',
    };
  };
  const fingerprint = value => JSON.stringify([value.__openai_measurement_consent, value.__openai_oppref, value.__openai_obref]);
  const flush = async () => {
    if (writing) return;
    writing = true;
    try {
      while (desired && fingerprint(desired) !== savedFingerprint) {
        const value = desired;
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/update.js`, {
          method: 'POST', credentials: 'same-origin', keepalive: true,
          headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: value }),
          signal: AbortSignal.timeout(5000),
        });
        if (!response.ok) break;
        savedFingerprint = fingerprint(value);
      }
    } catch {} finally { writing = false; }
  };
  window.selsilOpenaiSyncCart = () => { desired = attributes(); return flush(); };
  document.addEventListener('visitorConsentCollected', window.selsilOpenaiSyncCart);
  // Standart sepet formunda özel alanlar submit'in kendisine de eklenir.
  document.addEventListener('submit', (event) => {
    if (!event.target.matches?.('form[action$="/cart"]')) return;
    const value = attributes();
    for (const [key, data] of Object.entries(value)) {
      let input = event.target.querySelector(`[name="attributes[${key}]"]`);
      if (!input) {
        input = document.createElement('input'); input.type = 'hidden';
        input.name = `attributes[${key}]`; event.target.appendChild(input);
      }
      input.value = data;
    }
    window.selsilOpenaiSyncCart();
  }, true);
  let attempts = 0;
  const connect = () => {
    if (typeof window.Shopify?.customerPrivacy?.marketingAllowed === 'function' &&
        typeof window.Shopify?.customerPrivacy?.saleOfDataAllowed === 'function') window.selsilOpenaiSyncCart();
    else if (attempts++ < 40) setTimeout(connect, 100);
  };
  connect();
  // SDK çerezleri asenkron oluşabilir; sadece değişen referanslar tekrar yazılır.
  for (const delay of [1000, 3000, 5000]) setTimeout(window.selsilOpenaiSyncCart, delay);
})();
